import React, { useEffect, useRef, useState } from 'react';
import { WebPlayer } from '@antmedia/web_player';
import { Button, IconButton } from '@material-ui/core';
import CloseRoundedIcon from '@material-ui/icons/CloseRounded';
import InfoRoundedIcon from '@material-ui/icons/InfoRounded';
import VolumeOffIcon from '@material-ui/icons/VolumeOff';
import VolumeUpIcon from '@material-ui/icons/VolumeUp';
import './styles.css';
import PropTypes from 'prop-types';

const Player = ({ sessionId, shouldReplay }) =>
{
	const playerRef = useRef();
	const placeHolderRef = useRef();
	const embeddedPlayerRef = useRef(null);

	const playOrderLocal = [ 'hls' ];
	const [ isPlayerMuted, setPlayerMuted ] = useState(false);
	const [ audioMuted, setAudioMuted ] = useState(false);
	const [ hover, setHover ] = useState(false);

	// New state to trigger replay
	const [ hasUnmuted, setHasUnmuted ] = useState(false);
	// Function to play the video
	const playVideo = async () =>
	{
		if (embeddedPlayerRef && embeddedPlayerRef.current)
		{
			await embeddedPlayerRef.current.play();
			setPlayerMuted(embeddedPlayerRef.current.isMuted());
			// .then(() =>
			// {
			// 	console.log('Video playing', embeddedPlayerRef.current.isMuted());
			// 	setPlayerMuted(embeddedPlayerRef.current.isMuted());
			// })
			// .catch((error) =>
			// {
			// 	console.error(`Error while playing video: ${error}`);
			// });
		}
	};

	// Function to initialize the player
	const initializePlayer = () =>
	{
		if (playerRef && playerRef.current)
		{
			embeddedPlayerRef.current = new WebPlayer({
				streamId         : sessionId,
				httpBaseURL      : import.meta.env.VITE_streaming,
				videoHTMLContent : '<video id="video-player" class="video-js vjs-default-skin vjs-big-play-centered" controls playsinline style="width:100%;height:100%;display:flex;"></video>',
				playOrder        : playOrderLocal
			}, playerRef.current, placeHolderRef.current);

			embeddedPlayerRef.current.initialize()
				.then(() =>
				{
					console.log('Player initialized');
					playVideo();
				})
				.catch((error) =>
				{
					console.error(`Error while initializing embedded player: ${error}`);
				});
		}
	};

	// Initialize player when component mounts or sessionId changes
	useEffect(() =>
	{
		console.log('asdjhsad sadasdsa dasjd ');
		initializePlayer();
		// Cleanup function to destroy player when component unmounts

		return () =>
		{
			if (embeddedPlayerRef.current)
			{
				embeddedPlayerRef.current.destroy();
			}
		};
	}, [ sessionId ]);

	// // Effect to handle replay
	// useEffect(() =>
	// {
	// 	if (shouldReplay)
	// 	{
	// 		setShouldPlay(true);
	// 	}
	// }, [ shouldReplay ]);

	// // Effect to play video when shouldPlay is true
	// useEffect(() =>
	// {
	// 	if (shouldPlay)
	// 	{
	// 		playVideo();
	// 		setShouldPlay(false);
	// 	}
	// }, [ shouldPlay ]);

	const handleUnmute = () =>
	{
		if (embeddedPlayerRef && embeddedPlayerRef.current)
		{
			embeddedPlayerRef.current.mutePlayer(false);
			setAudioMuted(false);
			setPlayerMuted(false);
			setHover(false);
			setHasUnmuted(true);
		}
	};

	const handleMute = () =>
	{
		if (embeddedPlayerRef && embeddedPlayerRef.current)
		{
			embeddedPlayerRef.current.mutePlayer(true);
			setAudioMuted(true);
		}
	};

	const handleMouseEnter = (event) =>
	{
		event.stopPropagation();
		setHover(true);
		setPlayerMuted(embeddedPlayerRef.current.isMuted());
	};

	const handleMouseOut = (event) =>
	{
		event.stopPropagation();
		setHover(false);
	};

	return (
		<div
			style={{ width: '100%', height: '100%', position: 'relative', display: 'flex', alignItems: 'center', flexDirection: 'column' }}
			onMouseLeave={handleMouseOut}
			onMouseEnter={handleMouseEnter}
			onTouchStart={handleMouseEnter}
			onTouchEnd={handleMouseOut}
		>
			<div
				ref={playerRef}
				id='video_container'
				className='flexCol aCntr jCntr fullH fullW pRel videoMuteHide'
				style={{ display: 'flex' }}
			/>
			{/* {(hover && !isPlayerMuted) && (
				<div className='flexCol aCntr jCntr pAbs fullW fullH'>
					<IconButton>
						<div className='flexInline pdngSM brdrRadius50 iconStyles'>
							{embeddedPlayerRef?.current?.mute && audioMuted
								? <VolumeOffIcon onClick={handleUnmute}/>
								: <VolumeUpIcon onClick={handleMute}/>
							}
						</div>
					</IconButton>
				</div>
			)} */}
			{/* <div className='flexInline pAbs iconstyles pdngSM'>
				<IconButton size='small' >
					<div className='flexInline pdngSM brdrRadius50 iconStyles'>
						{embeddedPlayerRef?.current?.mute && audioMuted
							? <VolumeOffIcon fontSize='small' onClick={handleUnmute} />
							: <VolumeUpIcon fontSize='small' onClick={handleMute} />
						}
					</div>
				</IconButton>
			</div>
			{isPlayerMuted && (
				<div className='flexRow aCntr jCntr fullW pAbs absStyles'>
					<div className='flexAutoRow playerPdng whiteBg brdrRadiusSM'>
						<div className='flexMinWidthRow aCntr jCntr brdrRSM pdngRSM'>
							<InfoRoundedIcon fontSize='small'/>
							<small className='pdngHSM'>Not hearing anything?</small>
							<Button
								disableElevation
								color='primary'
								variant='contained'
								style={{ fontSize: '10px' }}
								size='small'
								onClick={handleUnmute}
							>
								unmute
							</Button>
						</div>
						<div
							className='flexAutoRow aCntr jCntr playerPdng pointer'
							role='presentation'
							onClick={() => setPlayerMuted(false)}
						>
							<CloseRoundedIcon fontSize='small'/>
						</div>
					</div>
				</div>
			)} */}

			{hasUnmuted ? (
				<div className='flexInline pFix iconstyles'>
					<IconButton size='small'>
						<div className='flexInline pdngXS brdrRadius50 iconStyles'>
							{embeddedPlayerRef?.current?.mute && audioMuted
								? <VolumeOffIcon fontSize='small' onClick={handleUnmute} />
								: <VolumeUpIcon fontSize='small' onClick={handleMute} />
							}
						</div>
					</IconButton>
				</div>
			) : isPlayerMuted && (
				<div className='flexRow aCntr jCntr fullW pAbs absStyles'>
					<div className='flexAutoRow playerPdng whiteBg brdrRadiusSM'>
						<div className='flexMinWidthRow aCntr jCntr brdrRSM pdngRSM'>
							<InfoRoundedIcon fontSize='small'/>
							<small className='pdngHSM'>Not hearing anything?</small>
							<Button
								disableElevation
								color='primary'
								variant='contained'
								style={{ fontSize: '10px' }}
								size='small'
								onClick={handleUnmute}
							>
								unmute
							</Button>
						</div>
						<div
							className='flexAutoRow aCntr jCntr playerPdng pointer'
							role='presentation'
							onClick={() => setPlayerMuted(false)}
						>
							<CloseRoundedIcon fontSize='small'/>
						</div>
					</div>
				</div>
			)}
			<div
				ref={placeHolderRef}
				className='placeholder'
				style={{
					height         : '360px',
					overflow       : 'hidden',
					display        : 'flex',
					alignItems     : 'center',
					justifyContent : 'center',
					color          : '#ffffff'
				}}
			>
				The streaming will begin shortly...
			</div>
		</div>
	);
};

Player.propTypes = {
	sessionId    : PropTypes.string.isRequired,
	shouldReplay : PropTypes.bool
};

export default Player;